import classNames from 'classnames';
import type { FC } from 'react';

import './AppointmentItem.scss';
import DateIcon from './DateIcon';
import Highlighter from './Highlighter';
import Icon from './ui/Icon';

interface IAppointmentItem {
  title: string;
  address: string;
  date?: string;
  day?: string;
  month?: string;
  standalone?: boolean;
  multiCheckbox?: boolean;
  isChecked?: boolean;
  showDate?: boolean;
  onClick?: () => void;
}

const AppointmentItem: FC<IAppointmentItem> = ({
  standalone = false,
  showDate = false,
  onClick: handleClick,
  multiCheckbox = false,
  isChecked = false,
  title,
  address,
  date,
  day,
  month
}) => {
  const isClickable = !standalone && handleClick;

  return (
    <div
      className={classNames('appointment-item', {
        clickable: isClickable,
        'has-bell': !date
      })}
      onClick={() => isClickable && handleClick()}
    >
      {(showDate || !standalone) && day && month && (
        <DateIcon day={day} month={month} />
      )}
      {multiCheckbox && (
        <input type="checkbox" checked={isChecked} readOnly />
      )}
      <div className="appointment-item-info">
        <div className="title">
          <Highlighter text={title} disableHighlight={!isClickable} />
        </div>
        <div className="meta">
          {!standalone && date && (
            <div>
              <Icon icon="calendar" /> {date}
            </div>
          )}
          <div>
            <Highlighter text={address} disableHighlight={!isClickable} />
          </div>
        </div>
      </div>
      {!standalone && (
        <div className="action-icon">
          {date ? (
            <Icon icon="chevron-right" />
          ) : (
            <>
              <Icon icon="bell" />
              Erinnern
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default AppointmentItem;
